import { Component, Input, OnInit } from '@angular/core';
import { ToasterService } from './toaster.service';
import { Toast } from './toast.interface';

@Component({
  selector: 'app-toaster-container',
  template: `
    <app-toaster *ngFor="let toast of toasts; let i=index" 
      [toast]="toast" [i]="i"
      (remove)="remove($event)"></app-toaster>

  
  `,
  styles: []
})
export class ToasterContainerComponent implements OnInit {

  toasts: Toast[] = [];
  allowTostar: boolean = false;
  constructor(public toaster: ToasterService) {}

  ngOnInit() {
    this.allowTostar = false;
    this.toaster.toast$
      .subscribe(toast => {
        if (this.allowTostar) {
          this.toasts = [toast, ...this.toasts];
          setTimeout(() => this.toasts.pop(), toast.delay || 6000);
        }
      
      });
    setTimeout(() => this.allowTostar = true, 3000);
  }

  remove(index: number) {
    this.toasts = this.toasts.filter((v, i) => i !== index);
    this.toasts.splice(index, 1);
  }
}
